import SeoHead from '../../components/SeoHead';
import Hero from './components/Hero';
import AudienceSplit from './components/AudienceSplit';
import About from './components/About';
import Services from './components/Services';
import Method from './components/Method';
import ValueProposition from './components/ValueProposition';
import InternationalReach from './components/InternationalReach';
import CTA from './components/CTA';
import BibliotecaEstrategica from './components/BibliotecaEstrategica';
import Contact from './components/Contact';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'BN ĀGENZIA',
      alternateName: 'BN Agenzia International Placement',
      url: siteUrl,
      logo: `${siteUrl}/vite.svg`,
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'info@bnagenzia.com',
        contactType: 'customer service',
        availableLanguage: ['Spanish', 'English', 'German'],
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Puerto de Sagunto',
        addressRegion: 'Valencia',
        addressCountry: 'ES',
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'BN ĀGENZIA',
      description: 'Agencia boutique de colocación internacional en Europa',
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'es',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'BN ĀGENZIA – Agencia Internacional de Colocación Laboral en Europa',
      description: 'BN ĀGENZIA conecta empresas europeas con profesionales cualificados. Selección estratégica, acompañamiento real y procesos personalizados para talento internacional en Europa.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'es',
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <SeoHead
        title="BN ĀGENZIA – Agencia Internacional de Colocación Laboral en Europa"
        description="BN ĀGENZIA conecta empresas europeas con profesionales cualificados. Selección estratégica, acompañamiento real y procesos personalizados para talento internacional en Europa."
        keywords="agencia colocación internacional, empleo Europa, talento internacional, reclutamiento Europa, agencia boutique"
        canonical="/"
        schema={homeSchema}
      />
      <div className="min-h-screen bg-white">
        <Hero />
        <AudienceSplit />
        <About />
        <Services />
        <Method />
        <ValueProposition />
        <InternationalReach />
        <CTA />
        <BibliotecaEstrategica />
        <Contact />
        <Footer />
      </div>
    </>
  );
}